import React from "react";
import { STATUS_LABELS } from "@/lib/api";

const CLS = {
  slate:   "bg-slate-100 text-slate-700 border-slate-200",
  sky:     "bg-sky-50 text-sky-800 border-sky-200",
  indigo:  "bg-indigo-50 text-indigo-800 border-indigo-200",
  amber:   "bg-amber-50 text-amber-800 border-amber-200",
  emerald: "bg-emerald-50 text-emerald-800 border-emerald-200",
  red:     "bg-red-50 text-red-800 border-red-200",
  zinc:    "bg-zinc-100 text-zinc-700 border-zinc-200",
};

export default function RequestStatusBadge({ status, className = "" }) {
  const meta = STATUS_LABELS[status] || STATUS_LABELS.inviata;
  const cls = CLS[meta.color] || CLS.slate;
  return (
    <span data-testid={`req-status-${status}`}
          className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-md text-[11px] font-bold uppercase tracking-wide border ${cls} ${className}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${meta.dot}`} />
      {meta.label}
    </span>
  );
}
